import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /contract (no sub-tab) — C20-133.
 *
 * The prototype's `_moduleSubRoutes['contract']['']` entry routes to
 * `Screens.contractBaseline`. We honor the same shape by redirecting
 * `/contract` to `/contract/baseline` so the deep-link behavior is
 * stable and the sub-tab strip on the baseline page lights up the
 * "Baseline" tab.
 */
export const Route = createFileRoute('/engagements/$engagementId/contract/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/engagements/$engagementId/contract/baseline',
      params: { engagementId: params.engagementId },
    });
  },
});
